import IntegrationRequestForm from '../features/Integrations/components/IntegrationRequestForm';
import React from 'react';

const Feedback = () => {
  return (
    <div className="sm:flex min-h-screen items-start justify-center bg-gradient-to-r p-2 sm:p-4 from-[#ededed] to-[#dcdcdc]">
      <div className="w-full max-w-xl">
        <h2 className="truncate text-3xl font-normal my-4">Оставить заявку на интеграцию с УК</h2>
        <div className="bg-white shadow-3xl rounded-3xl p-4">
          <IntegrationRequestForm />
        </div>
      </div>
    </div>
  );
};
export default Feedback;
